
namespace RioERP.Inventory {
    export class BookInwardColumns {
        static columnsKey = 'Inventory.BookInward';
    }
}